import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button } from '@avangard/ui/core';

import { CommonHelper } from '@helpers';
import { PageFiltersToolbar } from '@modules/shared/organisms';
import { useEnqueueStacks } from '@modules/layout/hooks';
import {
    useSummaryFiltersQuery,
    useLazySummaryStudentsExportUrl,
} from '@modules/summary-results/hooks';
import { SummaryResultsFilterRequest } from '@modules/summary-results/requests';

type ToolbarFiltersProps = {
    canExport: boolean;
    hideDrawerFilterButton?: boolean;
};

const ExportStudentsButton = styled(Button)`
    min-width: initial;
    margin-inline-start: auto;
    padding: 0 8px;
`;

const ToolbarFilters = (props: ToolbarFiltersProps) => {
    const { canExport, hideDrawerFilterButton } = props;

    const { t } = useTranslation(['common', 'notifiers']);

    const { enqueueError } = useEnqueueStacks();

    const { filters: summaryFilters } = useSummaryFiltersQuery();
    const filter = new SummaryResultsFilterRequest(summaryFilters);

    const [getSummaryStudentsExportUrl, { loading }] = useLazySummaryStudentsExportUrl({
        onCompleted: data => {
            const url = data?.getSummaryStudentsExportUrl;

            if (!url) {
                enqueueError(t('notifiers:export.error'));
                return;
            }

            CommonHelper.downloadUrl(url);
        },
        onError: () => {
            enqueueError(t('notifiers:export.error'));
        },
    });

    const handleClickExportStudents = async () => {
        try {
            getSummaryStudentsExportUrl({ variables: { filter } });
        } catch (e) {
            throw e;
        }
    };

    return (
        <PageFiltersToolbar
            hideDrawerFilterButton={hideDrawerFilterButton}
            afterButtonChildren={
                canExport ? (
                    <ExportStudentsButton loading={loading} onClick={handleClickExportStudents}>
                        {t('common:blocks.export.students')}
                    </ExportStudentsButton>
                ) : null
            }
        />
    );
};

export { ToolbarFilters };
